import { brunchStore } from '../constants';

const masterClass = (masterUserId) => {
    const { user } = brunchStore.data;

    if (user && user.userId === masterUserId) {
        return 'txt_my';
    }

    return '';
};

export default masterClass;
